import Vue from 'vue'
import VueRouter from 'vue-router'


import Home from '@/components/Home.vue'

import BuyAccounts from '@/components/BuyAccounts.vue'
import BoostAccounts from '@/components/BoostAccounts.vue'

import ProtectingBuyers from '@/components/ProtectBuyers.vue'
import ProtectingSellers from '@/components/ProtectSellers.vue'
import Vanguard from '@/components/Vanguard.vue'

import ChoosingAccounts from '@/components/ChoosingAccounts.vue'
import Contact from '@/components/Contact.vue'

import Login from '@/components/Login.vue'
import MyAccount from '@/components/MyAccount.vue'

import Listing from '@/components/Listing.vue'


import firebase from 'firebase/app'

Vue.use(VueRouter);

const routes = [
    {
        path:'/', 
        component:Home
    },
    {
        path: '/login',
        component:Login,
        meta: {
            title: "Login | ValorantAccounts"
        }        
    },
    {
        path: '/myaccount',
        component:MyAccount,
        meta: {
            requiresAuth: true,
            title: "My Account | ValorantAccounts"
        }
    },
    {
        path:'/buy', 
        component: BuyAccounts,
        meta: {
            title: "Buy Accounts | ValorantAccounts"
        }
    },
    {
        path: '/boost',
        component: BoostAccounts,
        meta: {

            title: "Boost Accounts | ValorantAccounts"
        }        
    },
    {
        path:'/protectingbuyers',
        component: ProtectingBuyers,
        meta: {
            title: "Protecting Buyers | ValorantAccounts"
        }
    },
    {
        path:'/protectingsellers',
        component: ProtectingSellers,
        meta: {
            title: "Protecting Sellers | ValorantAccounts"
        }        
    },
    {
        path:'/vanguard',
        component: Vanguard,
        meta: {
            title: "Our Stance on Vanguard | ValorantAccounts"
        }        
    },
    {
        path:'/choosingaccounts',
        component: ChoosingAccounts,
        meta: {
            title: "Choosing Accounts | ValorantAccounts"
        }        
    },    
    {
        path:'/contact',
        component: Contact,
        meta: {
            title: "FAQ & Contact | ValorantAccounts"
        }        
    },
    {
        path:'/faq',
        redirect: '/contact'
    },
    {
        path:'/listing/:id',
        component:Listing,
        meta: {
            title: "Listing Info | ValorantAccounts",
            requiresAuth: true
        }         
    },

    {
        path:'*',
        redirect: '/'      
    }

  ];

  const router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior() {
      document.getElementById('app').scrollIntoView();
  }  
  
  })

//Nav Guards
router.beforeEach((to, from, next) => {
    //Check for the requiresAuth flag
    if (to.matched.some(record => record.meta.requiresAuth)) {
        //if NOT logged in
        if (!firebase.auth().currentUser) {
            //Go to the login page
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath
                }
            });
        } else {
            //if logged in Proceed to route
            next();
        }
    } else if (to.matched.some(record => record.meta.requiresGuest)) {
        //Check if logged in
        if (firebase.auth().currentUser) {
            //Go to your account
            next({
                path: '/myaccount',
                query: {
                    redirect: to.fullPath
                }
            })
        }
    } else {
        next();
    }
})


const DEFAULT_TITLE = "ValorantAccounts | Buy Valorant Accounts and Valorant Boosting"

router.afterEach((to, from) => {
    document.title = to.meta.title || DEFAULT_TITLE
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js